export const APP_CONFIG = {
  name: import.meta.env.VITE_APP_NAME || 'Bajar Admin',

  api: {
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api/v1',
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  },

  storage: {
    prefix: import.meta.env.VITE_STORAGE_PREFIX || 'bajar_admin_',
    keys: {
      accessToken: 'access_token',
      refreshToken: 'refresh_token',
      user: 'user',
      theme: 'theme',
      language: 'language',
    }
  },

  pagination: {
    defaultPageSize: 20,
    pageSizes: [10, 20, 50, 100],
  },
} as const
